// import { allBooksCategories } from "../../data/CategoriesData"
import { Link, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { apiFetch } from '../../hooks/apiFetch';
import moment from 'moment';
import { useForm } from 'react-hook-form';
import Cookies from 'js-cookie';
import { ToastContainer, toast } from 'react-toastify';
import SuccessErrorMsg from '../../utilities/SuccessErrorMsg';
import { RiyalImgWHT } from '../../components/common/RiyalImg';
import { useTranslation } from 'react-i18next';
import SampleBook from "../../assets/defaults/BookSample-1.png";
import { addBooksFav } from '../../hooks/apiAxios';
import { useUserFav } from '../../context/User/UserFavContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import ReactHtmlParser from 'react-html-parser';
import { useLibCategory } from '../../context/LibraryCategoryContext';

export default function LibraryBook() {
    const [selectedBook, setSelectedBook] = useState("");
    const [error, setError] = useState(null);
    const { register, handleSubmit, formState: { errors } } = useForm();
    const [loading, setLoading] = useState(false);
    const { bookSetId } = useParams()
    // const {  bookSetTitle } = useParams()
    const { t, i18n } = useTranslation();
    const { favBooks } = useUserFav();
    const { libCategory } = useLibCategory();

    console.log(selectedBook?.data?.category);

    // Check if the current book is in the user's favorites
    const isFav = Array.isArray(favBooks?.data?.result)
        ? favBooks.data.result.some(book => book.bookId === selectedBook?.data?.id)
        : false;


    const selectedBookCategory = Array.isArray(libCategory) && selectedBook?.data?.category?.name
        ? libCategory.find(cat => cat.name === selectedBook.data.category.name)
        : null;

    useEffect(() => {
        async function fetchLibrary() {
            try {
                const book = await fetch(`${process.env.REACT_APP_MASAR_API_URL}/library/books/${bookSetId}`, {
                    method: "GET",
                    headers: {
                        "accept": "*/*"
                    },
                    body: JSON.stringify()
                });
                const responseData = await book.json();
                setSelectedBook(responseData);
                // console.log(book);
            } catch (err) {
                setError(t("errorGetData"), err);
            }
        }

        fetchLibrary();
    }, [bookSetId, t]);

    moment.locale('en');

    async function onSubmit(data) {
        if (!Cookies.get('token')) {
            return (
                i18n.language === "ar" ?
                    toast.warn(<p className="p-0 m-0">تأكد من  <Link to={`/${i18n.language}/logIn`}>تسجيل الدخول</Link> للشراء</p>) :
                    toast.warn(<p className="p-0 m-0">Make sure to <Link to={`/${i18n.language}/logIn`}>Log in</Link> to buy</p>)
            )
        }
        setLoading(true);

        try {
            const response = await apiFetch(`${process.env.REACT_APP_MASAR_API_URL}/carts/${bookSetId}`, {
                method: "POST",

                body: JSON.stringify(data)
            });

            // Redirect to another page after successful submission
            if (response.isSuccess) {
                // navigate('/');
                toast.success(t("OrderInCart"))
                setTimeout(() => {
                    window.location.reload();
                    // navigate('/masarLibrary');
                }, 3000);
                // setSuccess(true)
            } else {
                // console.log(response, response.message, response.status);
                toast.error(t("errorTryAgain"), response.message);
            }
        } catch (error) {
            console.error("Error during form submission: ", error); // Debug: Check error
            switch (error.response.status) {
                case 403:
                    i18n.language === "ar" ?
                        toast.error(<p className="p-0 m-0">تأكد من  <Link to={`/${i18n.language}/logIn`}>تسجيل الدخول</Link></p>) :
                        toast.error(<p className="p-0 m-0">Make sure to <Link to={`/${i18n.language}/logIn`}>Log in</Link></p>);
                    break;
                case 500:
                    i18n.language === "ar" ?
                        toast.error(<p className="p-0 m-0">تأكد من  <Link to={`/${i18n.language}/logIn`}>تسجيل الدخول</Link> أو تواصل مع الدعم</p>) :
                        toast.error(<p className="p-0 m-0">Make sure to <Link to={`/${i18n.language}/logIn`}>Log in</Link> or contact support</p>);
                    break;
                case 400:
                    toast.warn(t("errorCorrectData"));
                    break;
                default:
                    toast.warn(t("errorGetSupport"));
            }

        } finally {
            setLoading(false);

            // navigate('/masarLibrary');

        }
    }

    async function handleFavAdd(id) {
        setLoading(true);

        try {
            const response = await addBooksFav(id);

            if (response.data.isSuccess) {
                // setDataUpdate(true);
                toast.success(t("SuccessMessage"))
                setTimeout(() => {
                    window.location.reload();
                }, 3000);

            } else {
                toast.error(t("errorTryAgain"));
            }
        } catch (error) {
            console.error("Error during form submission: ", error);
            toast.warn(t("errorGetSupport"));


        } finally {
            setLoading(false);

        }
    }

    // Add check for libCategory
    if (!Array.isArray(libCategory)) {
        return null; // or return a loading state
    }


    if (error) {
        return <div className="text-center my-4 text-danger">{error}</div>;
    }

    if (!selectedBook) {
        return <div className="loader" role="status" aria-live="polite" aria-label="Loading"></div>;
    }
    return (
        <div className='container'>
            <Link type="button" className="btn-masar btn-dark-orange mx-2 mt-2 text-decoration-none"
                to={`/${i18n.language}/masarLibrary`}
            >{t("Library")}</Link>
            <div className='container col-12 col-md-10 mt-2'>
                <div className="p-4 bg-dark-beige rounded">
                    <div className="bookPage-box position-relative d-flex gap-3 flex-column flex-md-row">
                        <div className="bookPage-img position-relative">
                            <FontAwesomeIcon
                                onClick={() => handleFavAdd(selectedBook?.data?.id)}
                                icon={faHeart}
                                className={`books-Fav-Icon position-absolute bottom-0 end-0 me-2 mb-2 fs-3 ${isFav ? "c-darkOrange" : "text-white"}`}
                            />
                            <img
                                crossOrigin="anonymous" className="rounded img-fluid"
                                src={selectedBook?.data?.thumbnail ? selectedBook?.data?.thumbnail : SampleBook}
                                alt={`book-id-${selectedBook?.data?.id}`} />

                        </div>
                        <div className="d-flex flex-column justify-content-between text-white col-12 col-md-6">
                            <div>
                                <h5 className='mb-2'>{selectedBook?.data?.title}</h5>
                                {/* NOTE: To add book title in English and Book details */}
                                <h6 className='bg-dark-orange rounded text-center p-1 col-4 my-4'>
                                    {selectedBook?.data?.price} <RiyalImgWHT />
                                </h6>
                            </div>
                            <table className="table table-sm book-data">
                                <tbody>
                                    <tr>
                                        <th scope="row">{t("Author")}</th>
                                        <td>{selectedBook?.data?.author}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">{t("PublishDate")}</th>
                                        <td>{selectedBook?.data?.publishedDate}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">{t("bookCategory")}</th>
                                        <td>
                                            {selectedBookCategory
                                                ? (i18n.language === "ar" ? selectedBookCategory.nameAr : selectedBookCategory.name)
                                                : selectedBook?.data?.category?.name}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">{t("PageCount")}</th>
                                        <td>{selectedBook?.data?.numberOfPages}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className={`bookPage-status text-start ${selectedBook?.data?.available ? "border-lightOrange" : "border-lightBeige"} position-absolute ${i18n.language === "ar" ? "bookPage-status-Ar" : "bookPage-status-En"}`}>
                            {selectedBook?.data?.available ? t("Available") : t("printCopy")}
                        </div>
                    </div>
                </div>
                <div className='d-flex flex-column flex-md-row col-12 align-items-center align-items-md-start justify-content-md-between'>
                    <div className='col-12 col-md-8'>
                        <h6 className='py-4 c-darkOrange'>{t("bookDetails")}</h6>
                        {/* <p className='book-Desc'>{selectedBook?.data?.description}</p> */}
                        <div className='book-Desc'>{ReactHtmlParser(selectedBook?.data?.description)}</div>
                    </div>
                    {!loading ?
                        <form className='d-flex flex-column text-center col-6 col-md-3 mt-4' onSubmit={handleSubmit(onSubmit)}>
                            <label htmlFor="quantity">{t("requestQty")}</label>
                            <input
                                id='quantity'
                                className='form-control w-75 mx-auto'
                                type="number"
                                min="1"
                                step="1"
                                {...register("quantity", {
                                    required: "required",
                                    min: {
                                        value: 1,
                                        message: t("minQty")
                                    },
                                    valueAsNumber: true
                                })} />
                            {errors.quantity && <p className='errors-msg bg-warning p-1 rounded'>{t("minQty")}</p>}


                            <button className="float-end btn btn-masar btn-dark-orange mt-2" type="submit">{t("addToCart")}</button>
                            <SuccessErrorMsg
                                ToastContainer={ToastContainer}
                            />
                            {/* {errorMessage &&
                            <div className="alert alert-danger alert-dismissible fade show" role="alert">
                                {errorMessage}
                                <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                            </div>} */}
                            {/* {success &&
                            <div className="alert alert-success alert-dismissible fade show" role="alert">
                                طلبكم في السلة
                                <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                            </div>} */}
                        </form>

                        : <div className="loader" role="status" aria-live="polite" aria-label="Loading"></div>
                    }
                </div>
                {/* <OurBooks /> */}
            </div>
        </div>
    );
}
